"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ICON_SIZE_XSMALL = exports.ICON_SIZE_XLARGE = exports.ICON_SIZE_SMALL = exports.ICON_SIZE_MEDIUM = exports.ICON_SIZE_LARGE = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.assign.js");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _icons = _interopRequireDefault(require("@ant-design/icons"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _const = require("../../const");

var _excluded = ["icon", "className", "size", "sizePx"];
var _default = AppIcon;
exports.default = _default;
var ICON_SIZE_XSMALL = 'xsmall';
exports.ICON_SIZE_XSMALL = ICON_SIZE_XSMALL;
var ICON_SIZE_SMALL = 'small';
exports.ICON_SIZE_SMALL = ICON_SIZE_SMALL;
var ICON_SIZE_MEDIUM = 'medium';
exports.ICON_SIZE_MEDIUM = ICON_SIZE_MEDIUM;
var ICON_SIZE_LARGE = 'large';
exports.ICON_SIZE_LARGE = ICON_SIZE_LARGE;
var ICON_SIZE_XLARGE = 'xlarge';
exports.ICON_SIZE_XLARGE = ICON_SIZE_XLARGE;

function AppIcon(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? ICON_SIZE_SMALL : _ref$size,
      sizePx = _ref.sizePx,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var sizeStr = sizePx ? "".concat(sizePx, "px") : '';

  if (!sizeStr) {
    switch (size) {
      case ICON_SIZE_XSMALL:
        sizeStr = '16px';
        break;

      case ICON_SIZE_MEDIUM:
        sizeStr = '24px';
        break;

      case ICON_SIZE_LARGE:
        sizeStr = '32px';
        break;

      case ICON_SIZE_XLARGE:
        sizeStr = '64px';
        break;

      case ICON_SIZE_SMALL:
      default:
        sizeStr = '18px';
        break;
    }
  }

  return /*#__PURE__*/_react.default.createElement(_icons.default, Object.assign({
    className: (0, _classnames.default)('AppIcon', className),
    component: function component() {
      return typeof icon === 'string' ? /*#__PURE__*/_react.default.createElement("img", {
        src: "".concat(_const.cdnUrl, "/nnj/icon/").concat(icon, ".svg"),
        alt: icon,
        width: sizeStr,
        height: sizeStr
      }) : _react.default.cloneElement(icon, {
        width: sizeStr,
        height: sizeStr
      });
    }
  }, rest));
}